import { type UseQueryResult, useQuery } from 'react-query';
import { WarrantParticipantService } from '../../services/wealthlane-captable-services';

const useGetWarrantVestingSchedule = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  warrantId: string,
  enabled: boolean = true
): UseQueryResult<any | undefined, unknown> => {
  return useQuery(
    ['getWarrantVestingSchedule', warrantId],
    async () => {
      return await handleRequest(
        WarrantParticipantService.getApiCapTableApiAppWarrantParticipantParticipantWarrantVestingSchedule(warrantId)
      );
    },
    { enabled: enabled && !!warrantId }
  );
};

export default useGetWarrantVestingSchedule;
